/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetReportHeaderQueryResult } from '../../models/get-report-header-query-result';

export interface ApiProjectDailyTaskReportsGetReportHeaderGet$Plain$Params {
  ProjectId?: string;
}

export function apiProjectDailyTaskReportsGetReportHeaderGet$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectDailyTaskReportsGetReportHeaderGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetReportHeaderQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectDailyTaskReportsGetReportHeaderGet$Plain.PATH, 'get');
  if (params) {
    rb.query('ProjectId', params.ProjectId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetReportHeaderQueryResult>;
    })
  );
}

apiProjectDailyTaskReportsGetReportHeaderGet$Plain.PATH = '/api/ProjectDailyTaskReports/GetReportHeader';
